import Modal, { ModalBody } from '~/components/common/modal';
import {
   WhatsappIcon,
   TwitterIcon,
   FacebookIcon,
   LinkedinIcon,
   EmailIcon,
   FacebookShareButton,
   EmailShareButton,
   TwitterShareButton,
   LinkedinShareButton,
   WhatsappShareButton,
} from 'react-share';
import { Translate } from '~/i18n';
import Button from '~/components/common/button';
import { isJarir } from '~/utils/theme';

const AboutModal = ({ share_title, share_description, sharing, stopSharing }: any) => {
   return (
      <Modal size="xs" node="share" onClickOutside={stopSharing} open={sharing}>
         <ModalBody className="px-6 py-6">
            <div className="grid grid-cols-5 gap-2">
               <FacebookShareButton
                  className="flex justify-center focus:outline-none focus:ring-1"
                  url={window.location.href}
                  hashtag={isJarir ? '#jarirtickets' : '#halayalla'}
                  quote={share_description}>
                  <FacebookIcon round size={48} />
               </FacebookShareButton>
               <WhatsappShareButton
                  className="flex justify-center"
                  url={window.location.href}
                  title={share_title}>
                  <WhatsappIcon round size={48} />
               </WhatsappShareButton>
               <TwitterShareButton
                  className="flex justify-center"
                  url={window.location.href}
                  title={share_title}
                  hashtags={isJarir ? ['jarirtickets'] : ['halyalla']}
                  related={isJarir ? ['JarirBookstore'] : ['halayalla']}>
                  <TwitterIcon round size={48} />
               </TwitterShareButton>
               <LinkedinShareButton
                  className="flex justify-center"
                  url={window.location.href}
                  title={share_title}
                  summary={share_description}
                  source={isJarir ? 'Jarir Tickets' : 'HalaYalla'}>
                  <LinkedinIcon round size={48} />
               </LinkedinShareButton>
               <EmailShareButton
                  className="flex justify-center"
                  url={window.location.href}
                  subject={share_title}
                  body={share_description}>
                  <EmailIcon round size={48} />
               </EmailShareButton>
            </div>

            <div className="flex justify-center w-full text-center mt-7">
               <Button onClick={stopSharing} className="px-10 !py-2.5" type="secondary">
                  <Translate id="common:cancel" />
               </Button>
            </div>
         </ModalBody>
      </Modal>
   );
};
export default AboutModal;
